import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { BRAND_NAME, CONTACT_PHONE, CONTACT_PHONE_HREF, CONTACT_EMAIL, CONTACT_EMAIL_HREF } from "@/constants/brand";

export const Footer = () => {
  return (
    <footer className="relative border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img src={process.env.PUBLIC_URL + "/logo.png"} alt="1Rupee Clinic" className="h-12 w-auto object-contain" />
            </div>
            <p className="mt-4 text-sm text-muted-foreground max-w-sm leading-relaxed">
              A chain of community clinics and diagnostic centres bringing affordable, modern
              healthcare to every neighbourhood.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-foreground mb-4">
              Membership
            </div>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li><Link to="/generate" className="hover:text-foreground transition-colors">Generate card</Link></li>
              <li><Link to="/verify" className="hover:text-foreground transition-colors">Verify card</Link></li>
              <li><a href="#benefits" className="hover:text-foreground transition-colors">Benefits</a></li>
              <li><a href="#faq" className="hover:text-foreground transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-foreground mb-4">
              Reach us
            </div>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-2.5">
                <Phone className="h-4 w-4 mt-0.5 text-primary" />
                <a href={CONTACT_PHONE_HREF} className="hover:text-primary transition-colors">{CONTACT_PHONE}</a>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="h-4 w-4 mt-0.5 text-primary" />
                <a href={CONTACT_EMAIL_HREF} className="hover:text-primary transition-colors">{CONTACT_EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} {BRAND_NAME}. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-foreground">Privacy</a>
            <a href="#" className="hover:text-foreground">Terms</a>
            <a href="#" className="hover:text-foreground">Refunds</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
